<template>
  <div class="role">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">
          {{ $t('label.list.role') }}
        </h3>
        <div class="box-tools pull-right">
          <router-link
            v-if="can([Permissions.backend.administration.role.store])"
            type="button"
            :to="{name: 'create-role'}"
            class="btn btn-primary btn-sm"
          >
            {{ $t('label.newRole') }}
          </router-link>
        </div>
      </div>
      <div class="box-body">
        <Datatable
          ref="oTable"
          table-id="role-table"
          :columns="columns"
          url="api/backend/role/datatable"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Permissions from '@/permissions'
import Datatable from '@/components/Datatable'

export default {
  name: 'List',
  metaInfo () {
    return {
      title: this.$t('string.roleList'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  },
  components: { Datatable },
  data () {
    return {
      Permissions
    }
  },
  computed: {
    columns () {
      const self = this
      return [
        {
          data: 'name',
          name: 'name',
          title: self.$t('table.name')
        },
        {
          data: 'display_name_en',
          name: 'display_name_en',
          title: self.$t('table.nameInEnglish'),
          render: (data) => {
            if (data !== null) {
              return data
            }
            return this.$t('string.na')
          }
        },
        {
          data: 'display_name_km',
          name: 'display_name_km',
          title: self.$t('table.nameInKhmer'),
          render: (data) => {
            if (data !== null) {
              return data
            }
            return this.$t('string.na')
          }
        },
        {
          data: 'number_of_users',
          name: 'number_of_users',
          searchable: false,
          orderable: false,
          title: self.$t('table.numberOfUsers')
        },
        {
          data: 'created_at',
          name: 'created_at',
          width: '150px',
          searchable: false,
          title: self.$t('table.createdAt'),
          render: (data) => {
            return this.getDateFormat(data)
          }
        },
        {
          data: 'action',
          name: 'action',
          searchable: false,
          orderable: false,
          width: '70px',
          title: self.$t('table.action')
        }
      ]
    }
  },
  mounted () {
    this.loadAction()
  },
  methods: {
    onDelete (id) {
      this.onConfirm({})
        .then((accept) => {
          if (accept) {
            this.$axios.post(process.env.VUE_APP_API + '/api/backend/role/delete', {
              id: id
            }).then(() => {
              this.showSwalSuccess()
              this.$refs.oTable.draw(true)
            }).catch(error => {
              this.onResponseError(error)
            })
          }
        })
    },
    loadAction () {
      const self = this
      this.clearEventHandler([
        '.btn-edit',
        '.btn-delete'
      ])
      $(document).on('click', '.btn-edit', function () {
        self.$router.push({ name: 'edit-role', params: { id: $(this).attr('data-id') } })
      })
      $(document).on('click', '.btn-delete', function () {
        self.onDelete($(this).attr('data-id'))
      })
    }
  }
}
</script>

<style scoped>

</style>
